import React from "react";
import { Button, Container, Row, Col, ThumbsUpIcon } from "shared-portal-component";
import { useSelector } from "react-redux";

import { useAppDispatch } from "@/store";
import { setShowSuccessScreen, setStep } from "@/store/slices/createSix/createSixSlice";
import { selectInvitedUser } from "@/store/selectors/createSix";

const StepSuccess: React.FC = () => {
  const dispatch = useAppDispatch();
  const invitedUser = useSelector(selectInvitedUser);

  const handleAdd = () => {
    dispatch(setShowSuccessScreen(false));
    dispatch(setStep("NewExternalParticipant"));
  };

  const handleSuccessProceed = () => {
    dispatch(setShowSuccessScreen(false));
    dispatch(setStep("ExternalParticipants"));
  };

  return (
    <Container fluid>
      <Row spacing="none">
        <Col size={1}>
          <ThumbsUpIcon size="2x" />
        </Col>
        <Col size={11}>
          {(invitedUser != null) ? (
            <>
              <div>
                We’ve sent a Welcome email to <strong>{invitedUser.name}</strong> at{" "}
                <strong>{invitedUser.email}</strong>.
              </div>
              <br />
              <div>
                Once this new external user completes the registration process, they will have
                access to this SIX and its contents.
              </div>
              <div className="pt-16 pb-8">
                If you would like to add another new External User, click the Add button.
                Otherwise, click Proceed to create the new SIX.
              </div>
            </>
          ) : (
            <>
              <div>
                We’ve sent a Welcome email to the invited user.
              </div>
              <br />
              <div>
                Once the new external user completes registration, they’ll have access to this SIX and its contents.
              </div>
              <div className="pt-16 pb-8">
                You can add another External User, or proceed to create the SIX.
              </div>
            </>
          )}
        </Col>
      </Row>

      <Row spacing="md" justify="center">
        <Button text="Add" variant="primary" size="md" onClick={handleAdd} />
        <Button text="Proceed" variant="primary" size="md" onClick={handleSuccessProceed} />
      </Row>
    </Container>
  );
};

export default StepSuccess;
